export const HOW_IT_WORKS_STEPS = [
  {
    n: "01",
    title: "Build your shelf",
    desc: "Add the books you own, want, or love. Organize gently — no pressure, no perfection.",
  },
  {
    n: "02",
    title: "Join a reader circle",
    desc: "Find a small group sharing weekly highlights. Warm conversations, not loud threads.",
  },
  {
    n: "03",
    title: "Read, share, repeat",
    desc: "Track progress, recommend favorites, and let the next story find its way to you.",
  },
];
